import { Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyDocTemplates({ formData, handleChange, userUUID }: any) {
  return (
    <div className="flex flex-col gap-4">
      <CreateDropZone
        title="Sample Project Plan"
        description="Gantt or timeline template."
        onFilesChange={(files) => handleChange?.('sampleProjectPlans', files)}
        userUUID={userUUID}
        files={formData?.sampleProjectPlans ?? []}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Quality Assurance Process"
            labelPlacement="outside"
            variant="bordered"
            placeholder="QA narrative or policy + ISO proof"
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            onChange={(e) => handleChange?.('qualityAssuranceText', e.target.value)}
            value={formData?.qualityAssuranceText}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Attachments'}
            description="."
            onFilesChange={(files) => handleChange?.('qualityAssuranceFile', files)}
            userUUID={userUUID}
            files={formData?.qualityAssuranceFile ?? []}
          />
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Documentation Standards"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Explain deliverable docs"
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            onChange={(e) => handleChange?.('documentationStandardsText', e.target.value)}
            value={formData?.documentationStandardsText}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Template files'}
            description="."
            onFilesChange={(files) => handleChange?.('documentationStandardsFile', files)}
            userUUID={userUUID}
            files={formData?.documentationStandardsFile ?? []}
          />
        </div>
      </div>
      <Textarea
        label="Development & Delivery Methodology"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Summarise sprint cadence, stakeholder engagement, backlog grooming, change control, and tooling. Procurement panels often award method points for demonstrably disciplined delivery frameworks."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('developmentMethodology', e.target.value)}
        value={formData?.developmentMethodology}
      />
      <Textarea
        label="Template Library"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Enumerate existing boilerplate (security concept, risk register, communication plan, company overview text) we may insert verbatim into bids, saving preparation time."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('templateLibrary', e.target.value)}
        value={formData?.templateLibrary}
      />
    </div>
  )
}
